// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataxpl } from "../../../icons/mono/build/icon-stataxpl.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataxplIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataxpl.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataxplIcon.displayName = 'StataxplIcon';
}

export default StataxplIcon;